export default "__VITE_ASSET__DigzUIj8__"